"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSO_KNOWLEDGE_BASE_DOCUMENT = exports.SSO_SAML_AUDIENCE_ENDPOINT = exports.SSO_SAML_ACS_ENDPOINT = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var isQa = _enviro.default.isQa('settings-ui');

var API_ORIGIN = "https://api.hubspot" + (isQa ? 'qa' : '') + ".com";
var SSO_SAML_ACS_ENDPOINT = API_ORIGIN + "/login-api/v1/saml/acs";
exports.SSO_SAML_ACS_ENDPOINT = SSO_SAML_ACS_ENDPOINT;
var SSO_SAML_AUDIENCE_ENDPOINT = API_ORIGIN + "/login-api/v1/saml/login";
exports.SSO_SAML_AUDIENCE_ENDPOINT = SSO_SAML_AUDIENCE_ENDPOINT;
var SSO_KNOWLEDGE_BASE_DOCUMENT = 'https://knowledge.hubspot.com/articles/kcs_article/account/can-i-use-single-sign-on-sso-with-hubspot';
exports.SSO_KNOWLEDGE_BASE_DOCUMENT = SSO_KNOWLEDGE_BASE_DOCUMENT;